<div class="dashboard-dialog-title" fxLayout="row" fxLayoutAlign="space-between">
  <h4 [innerHTML]="title" mat-dialog-title></h4>
  <a class="dashboard-dialog-title__close-button" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </a>
</div>
